import LayoutStandard from '@/components/LayoutStandard';
import LoginForm from '@/components/LoginPage/LoginForm';
import usePageHeight from '@/hooks/usePageHeight';

function ShopifyLoginPage() {
  const pageHeight = usePageHeight();

  return (
    <LayoutStandard
      heading="Sign in to your Tapt account"
      backgroundColor="bg-gray-50"
    >
      <div
        className="sm:mx-auto sm:w-full sm:max-w-md lg:max-w-lg min-h-[50vh]"
        style={{ maxHeight: pageHeight }}
      >
        <div className="bg-white py-2 px-4 sm:rounded-lg sm:px-10 sm:py-8 lg:border lg:border-gray-100">
          <LoginForm
            config={{
              isShopify: true,
            }}
          />
        </div>
      </div>
    </LayoutStandard>
  );
}

export default ShopifyLoginPage;
